import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import React from 'react'
import {BoldSpan} from '../../../../../styledComponents/StyledSpan'
import {DialogTitle, TableCell} from '@mui/material'

export const FilterPanel = styled.div`
  width: 280px;
  font-size: 16px;
  padding: 15px;
  border: 1px solid ${Colors.AccentLight};
  background-color: ${Colors.Surface};
`
interface Props {
    children: React.ReactNode
}

export const Section: React.FC<Props> = props =>
    <BoldSpanForSection>{props.children}</BoldSpanForSection>

const BoldSpanForSection = styled(BoldSpan)`
  font-size: 16px;
`

export const FitTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding: 14px 0;
  }
`

export const StyledDialogTitle = styled(DialogTitle)`
  padding-bottom: 0!important;
  padding-left: 12px!important;
  padding-right: 12px!important;
`
